<template>
  <div class="headers" style="margin-top: -30px">
    <div :style="isEN ?'right: 0': 'left: 0'"
         id="mapOrder" class="MainMapCss scrollTop" v-if="CheckDisable && showModal">
      <mapir :style="isEN ?'right: 0': 'left: 0'"
             style="margin-top: 30px"
             :center="center"
             :apiKey="apiKey" @click="hv"
             class="MainMapCss_Sub">
        <mapAttributionControl/>
        <mapNavigationControl position="top-right"/>
        <mapGeolocateControl position="top-left"/>
        <mapScaleControl position="top-left"/>
        <mapMarker
            ref="markerr"
            :coordinates.sync="markerCoordinates"
            color="green"
            @click="markerOnClick"
            :draggable="true">
          <img alt="" src="https://api.cluna.app/file/download/png/1641123030729-w1c4gu2hk7.png" slot="marker"
               style="width: 5%"/>
          <mapPopup>
            <div>{{ oracle.translate("انتخاب آدرس") }}</div>
          </mapPopup>
        </mapMarker>
      </mapir>
    </div>

    <div class="headerCluna">
      <v-container>
        <v-row align="center">
          <v-col cols="8">
            <div class="d-flex flex-row align-content-center">
              <v-btn
                  color="#7ec352"
                  class="btn-store"
                  block
                  v-ripple role="button" @click="checkAvailability()"
                  @click.stop="drawer = !drawer">
                {{ oracle.translate('سبد خرید') }}
                <v-icon>mdi-cart</v-icon>
              </v-btn>
              <div
                  :style="(isEN ? 'left: -3px;' : 'right: -3px;') + 'text-align:center!important;'"
                  class="bdg-store font-weight-bold text-center" v-if="NumberBasket != null && NumberBasket > 0">
                {{ NumberBasket }}
              </div>
              <v-btn
                  outlined
                  color="#7ec352"
                  class="btn-log"
                  block
                  v-ripple role="button" @click="GoToProfile()">
                {{ oracle.translate(loginIsTrue ? "حساب کاربری" : "ورود / عضویت") }}
              </v-btn>
              <div class="d-flex flex-row align-content-center">
                <v-btn color="#7ec352" class="dl-app mrx-5 mlx-2" block>
                  <a :href="androidLink">
                    {{ oracle.translate('دانلود مستقیم اندروید') }}
                  </a>
                </v-btn>
                <!--              <v-col class="mrx-1" cols="2">-->
                <!--                <v-btn color="#7ec352" class="dl-google-play" block>-->
                <!--                  <a href="https://play.google.com/store/apps/details?id=ir.cluna.android">-->
                <!--                    دانلود از گوگل پلی-->
                <!--                  </a>-->
                <!--                </v-btn>-->
                <!--              </v-col>-->
                <v-btn color="#7ec352" class="dl-cafe-bazar" block>
                  <a href="https://cafebazaar.ir/app/ir.cluna.android">
                    {{ oracle.translate('دانلود از کافه بازار') }}
                  </a>
                </v-btn>
              </div>
            </div>
          </v-col>
          <v-col cols="4">
            <div class="l-headerCluna">
              <div
                  :class="
                  search === true ? 'searchWapper openWapper' : 'searchWapper'">
                <div
                    :class="
                    search === true ? 'searchBox openSearchBox' : 'searchBox'">
                  <v-text-field
                      hide-details="false"
                      solo
                      class="searchInput"
                      @keyup="handleChangeInput"
                      v-model="searchInput"
                      :placeholder="oracle.translate('جستجو محصول')"
                  ></v-text-field>
                </div>
              </div>

              <div :class=" listSearch.length === 0 ? 'listSearch' : 'listSearch listScroll w-100'">
                <div class="w-100" style="background-color: #7dc353">
                  <div
                      class="searchItem"
                      v-for="(item, cases) in listSearch"
                      :key="'cases-' + cases">
                    <router-link role="button" style="display: flex; flex-direction: row; align-items: center"
                                 :to="{name: 'single', query: {id: item.product_id }}">
                      <div class="imageSearch">
                        <img :src="item.product_icon" :alt="oracle.product_title(item)"/>
                      </div>
                      <div class="contentSearch">
                        <span class="multi-line f8">{{ oracle.product_title(item) }}</span>
                      </div>
                      <!--                            </a>-->
                    </router-link>
                  </div>
                </div>
              </div>

              <div
                  color="transparent"
                  class="btnClose"
                  v-ripple role="button" @click="closeSearch"
                  v-if="search">
                <v-icon>mdi-close-circle</v-icon>
              </div>
              <div class="search-headerCluna" v-ripple role="button" @click="search = true" v-else>
                <v-icon>mdi-magnify</v-icon>
              </div>

              <div class="like-headerCluna" v-ripple role="button" @click="dialoglog = false">
                <v-btn to="favorites">
                  <v-icon>mdi-heart</v-icon>
                </v-btn>
              </div>

              <v-btn rounded @click="toggleLanguage" class="language-switch">
                <div class="d-flex flex-row align-items-center align-content-center">
                  <i class="f8 mdi mdi-web mlx-1" style="color: #7dc353; margin-top: 2px"></i>
                  <span class="font-weight-bold" style="color: #7dc353">{{ isEN ? 'فارسی' : 'English' }}</span>
                </div>
              </v-btn>
            </div>
          </v-col>

        </v-row>
      </v-container>
    </div>
    <div class="logo-header d-none d-md-flex" style="background: #fff">
      <v-container>
        <v-row :justify="'space-between mt-3 mb-3'" style="direction: rtl !important;">
          <div class="cup-img-cluna">
            <img alt="" src="../assets/image/cup.png"/>
          </div>
          <div class="logo-img-cluna" role="button" @click="$router.push('/')">
            <img alt="" src="../assets/image/logo2.png"/>
          </div>
        </v-row>
      </v-container>
    </div>
    <div class="nav-cluna">
      <v-container style="padding:0">
        <div class="menu-cluna">
          <ul :class="['item-menuHumber', drawerMenu ? 'activeMenu' : '']">
            <router-link role="button"
                         tag="li"
                         active-class="router-link-active"
                         v-on:click.native="drawerMenu = !drawerMenu"
                         to="/"
                         exact>
              <a v-ripple role="button">{{ oracle.translate("خانه") }}</a>
            </router-link>
            <router-link role="button"
                         tag="li"
                         active-class="router-link-active"
                         v-on:click.native="drawerMenu = !drawerMenu"
                         to="/products"
                         exact>
              <a v-ripple role="button">{{ oracle.translate("محصولات") }}</a>
            </router-link>
            <router-link role="button"
                         tag="li"
                         active-class="router-link-active"
                         v-on:click.native="drawerMenu = !drawerMenu"
                         to="/stores"
                         exact>
              <a v-ripple role="button">{{ oracle.translate("لیست فروشگاه ها") }}</a>
            </router-link>
            <router-link role="button"
                         tag="li"
                         active-class="router-link-active"
                         v-on:click.native="drawerMenu = !drawerMenu"
                         to="/representation"
                         exact>
              <a v-ripple role="button">{{ oracle.translate("اخذ نمایندگی") }}</a>
            </router-link>
            <router-link role="button"
                         tag="li"
                         active-class="router-link-active"
                         v-on:click.native="drawerMenu = !drawerMenu"
                         to="job"
                         exact>
              <a v-ripple role="button">{{ oracle.translate("فرصت شغلی") }}</a>
            </router-link>
            <router-link role="button"
                         tag="li"
                         active-class="router-link-active"
                         v-on:click.native="drawerMenu = !drawerMenu"
                         to="/about"
                         exact>
              <a v-ripple role="button">{{ oracle.translate("درباره کلانا") }}</a>
            </router-link>
            <router-link role="button"
                         tag="li"
                         active-class="router-link-active"
                         v-on:click.native="drawerMenu = !drawerMenu"
                         to="/contact"
                         exact>
              <a v-ripple role="button">{{ oracle.translate("تماس با ما") }}</a>
            </router-link>
            <router-link role="button"
                         tag="li"
                         active-class="router-link-active"
                         v-on:click.native="drawerMenu = !drawerMenu"
                         to="/complaint"
                         exact>
              <a v-ripple role="button">{{ oracle.translate("ثبت نظر و پیشنهاد") }}</a>
            </router-link>
          </ul>
          <div class="menuHumber" v-ripple role="button" @click="drawerMenu = !drawerMenu">
            <v-icon>{{ drawerMenu ? "close" : "menu" }}</v-icon>
          </div>
        </div>
      </v-container>
    </div>

    <v-navigation-drawer
        style="z-index: 550;"
        v-model="drawer"
        :permanent="showModal"
        absolute
        :right="!isEN"
        class="navigation-css rounded">
      <template v-if="isAllowed != null && isAllowed">
        <div class="ModalCssBase" v-if="showModal">
          <div class="ModalCss d-flex flex-column prx-5 plx-5">
            <v-icon v-ripple @click="showModal = false" class="text-left mrx-auto mt-5 mb-5 float-left"
                    style="font-size: 28px;">clear
            </v-icon>
            <v-text-field class="mb-5"
                          persistent-hint
                          autofocus
                          :placeholder="oracle.translate('مثال: خانه')"
                          style="background-color: white;"
                          :hint="oracle.translate('عنوان آدرس انتخابی')"
                          v-model="address_title">
            </v-text-field>
            <v-textarea class="mb-5"
                        persistent-hint
                        autofocus
                        :placeholder="oracle.translate('مثال: بلوار کشاورز، خیابان کارگر شمالی، ساختمان سامان، پلاک 1166، واحد 601')"
                        style="background-color: white;"
                        :hint="oracle.translate('آدرس دقیق پستی خود را وارد نمائید')"
                        v-model="address_description">
            </v-textarea>
            <div class="d-flex flex-column mt-5"
                 style="margin-bottom: 100px; color: white !important; text-align: center !important; font-size: 13px">
              <v-btn v-ripple role="button" @click="CheckDisable = true"
                     style="width: 100%; color: white; background-color: #2ab0f7;">
                <v-icon class="mlx-1" color="white">person_pin_circle</v-icon>
                {{ oracle.translate('انتخاب آدرس از روی نقشه') }}
              </v-btn>
              <v-btn v-ripple role="button" @click="SetMap()" class="font-weight-bold mt-2"
                     style="width: 100%; color: white; background-color: #7dc353;">
                <v-icon class="mlx-1" color="white">check</v-icon>
                {{ oracle.translate('ذخیره آدرس') }}
              </v-btn>
            </div>
          </div>
        </div>

        <v-list-item class="title-drwer">
          <div class="header-drewer" style="border-bottom: 1px solid lightgray">
            <span class="font-weight-bold" style="font-size: 16px">{{ oracle.translate('سبد خرید') }}</span>
            <v-icon v-ripple role="button" @click="drawer = false">close</v-icon>
          </div>
          <div v-if="AllDataBasket.shop_name != null" class="choose-branch">
            <v-icon
                :style="isEN ? 'padding-right: 5px;' : 'padding-left: 5px;'"
                color="#7dc353">mdi-map-marker
            </v-icon>
            <span class="font-weight-bold" style="font-size: 14px;"
                  role="button" @click="$router.push({name: 'innerStore', query: {id: AllDataBasket.shop_id}})">
            {{ oracle.shop_name(AllDataBasket) }}
          </span>
            <i v-if="CheckBasket > 1" role="button" v-ripple @click="backStep"
               :class="isEN ? 'mdi-chevron-right' : 'mdi-chevron-left'" class="mdi mrx-auto"
               style="color: white; font-size: 25px !important;"></i>
          </div>
        </v-list-item>

        <v-divider></v-divider>

        <div class="box-products">
          <Placeholder class="mt-5" v-if="CheckBasket == 0"></Placeholder>
          <div v-if="CheckBasket == 1">
            <div class="d-flex flex-column" v-for="(item, num) in AllDataBasket.basket" :key="'num-' + num">
              <div class="box-product">
                <div class="box-product-r">
                  <div class="img-box-product">
                    <img :src="item.product_icon" :alt="oracle.product_title(item)"/>
                  </div>
                  <div class="text-box-product">
                    <h6 class="multi-line">{{ oracle.product_title(item) }}</h6>
                    <span>{{ oracle.format(item.product_sell_price) }} {{ oracle.translate('تومان') }}</span>
                  </div>
                </div>
                <div class="box-product-l">
                  <ul
                      style="direction: rtl !important; width: fit-content; padding-left: 0 !important; padding-right: 0 !important;">
                    <li v-ripple role="button"
                        @click="plusItem(item)">
                      <v-icon color="#fff">
                        control_point
                      </v-icon>
                    </li>
                    <li class="font-weight-bold"
                        style="color: white; padding: 0 10px 0 10px; font-size: 17px">
                      {{ item.product_count }}
                    </li>
                    <li v-ripple role="button"
                        @click="minusItem(item)">
                      <v-icon color="#fff">
                        remove_circle_outline
                      </v-icon>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="d-flex flex-column"
                   v-if="item.product_options != null && item.product_options.length > 0">
                <div role="button" @click="toggleItem(item)" class="flex-row d-flex align-center"
                     style="width: 100%; background-color: #7dc353;">
                <span class="mrx-2 mlx-2 white--text f8">{{ oracle.translate('انتخاب گزینه های') }}
                  <span class="white--text f9" style="font-weight: bold">{{ oracle.product_title(item) }}</span>
                  </span>
                  <i v-if="productExpanded[item.product_id] != null && productExpanded[item.product_id]"
                     class="mdi mdi-chevron-down-box-outline white--text f15 mrx-auto mlx-2"></i>
                  <i v-else
                     :class="isEN ? 'mdi-chevron-right-box-outline' : 'mdi-chevron-left-box-outline'"
                     class="mdi white--text f15 mrx-auto mlx-2"></i>
                </div>
                <div v-if="productExpanded[item.product_id] != null && productExpanded[item.product_id]"
                     class="d-flex flex-column">
                  <div class="d-flex flex-column" v-for="index in item.product_count" :key="index">
                  <span v-if="item.product_count > 1"
                        class="text--black f7 pt-1 prx-2 plx-2 pb-1" style="background-color: #807ec352">
                    {{ oracle.product_title(item) }} {{ counterTitle(index) }}
                  </span>
                    <div class="flex-row d-flex align-center" role="button" @click="setOption(item, index, option)"
                         style="width: 100%; border-bottom: 1px solid lightgrey"
                         v-for="(option, optionsIndex) in item.product_options" :key="optionsIndex">
                      <i v-if="productMap[item.product_id][index + '-'+ option.key]"
                         class="mdi mdi-check-circle f12 mrx-1 mlx-1" style="color: #7dc353"></i>
                      <i v-else class="mdi mdi-circle-outline f12 mrx-1 mlx-1" style="color: #7dc353"></i>
                      <span class="f9 mlx-auto" style="color: #7dc353">{{ option.key }}</span>
                      <span v-if="option.value != null && option.value.length > 0"
                            class="f10 font-weight-bold" style="color: #7dc353">{{ oracle.format(option.value) }}</span>
                      <span v-if="option.value != null && option.value.length > 0"
                            class="f7 font-weight-bold mrx-1 mlx-2"
                            style="color: #7dc353">{{ oracle.translate('تومان') }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style="padding: 20px">
              <div role="button" v-ripple
                   :style="item.id == selectedCoupon ? 'border: 3px solid #2ab0f7;' : ''"
                   style="background-color: #7dc353; margin: 20px 0; border-radius: 20px; width: 100%; padding: 10px"
                   class="d-flex flex-column" v-for="(item, n) in coupons" :key="'n-' + n"
                   @click="selectedCoupon = item.id">
                    <span class="font-weight-bold mlx-auto" style="color: white; font-size: 15px">
                        {{ (item.id == selectedCoupon ? "✓ " : "") + item.title }}
                    </span>
                <span class="mlx-auto mt-2 mb-2"
                      style="color: white; font-size: 11px">{{ item.expireText }}</span>
                <span v-if="item.id == selectedCoupon" class="mrx-auto"
                      style="background-color: #2ab0f7; width: fit-content;color: white ; border-radius: 25px; padding: 2px 10px; font-size: 12px;">✓ اعمال شد</span>
                <span v-else class="mrx-auto"
                      style="background-color: white; width: fit-content; color: #7dc353; border-radius: 25px; padding: 2px 10px; font-size: 12px;">● {{
                    oracle.translate('برای اعمال لمس کنید')
                  }}</span>
              </div>
            </div>
            <span class="mlx-auto mrx-5" style="font-size: 12px; color: #9a9696;" v-if="suggests.length > 0">
              {{ oracle.translate('سبد خرید خود را با این پیشنهادات تکمیل کنید!') }}
            </span>
            <div
                class="box-product"
                v-for="(item, number) in suggests"
                :key="'number-' + number">
              <div class="box-product-r">
                <div class="img-box-product">
                  <img :src="item.product_icon" :alt="oracle.product_title(item)"/>
                </div>
                <div class="text-box-product">
                  <h6 class="multi-line">{{ oracle.product_title(item) }}</h6>
                </div>
              </div>
              <span class="mrx-auto" role="button" v-ripple @click="plusItem(item)"
                    style="background-color: #2ab0f7; width: fit-content; color: white; border-radius: 25px; padding: 2px 10px; font-size: 12px;">+ {{
                  oracle.translate('افزودن')
                }}</span>
            </div>
          </div>
          <div v-if="CheckBasket == 2">
            <v-radio-group v-model="radios">
              <v-radio
                  :value="item.shop_id"
                  class="mrx-2"
                  :class="[{CssGun: item.shop_id == 1 && AllDataBasket.shop_delivery == false,},'labelStyle',]"
                  :style="{ 'display': (item.shop_id == 1 && AllDataBasket.shop_delivery == false) ? 'none' : 'flex'}"
                  v-for="(item, indexs) in store"
                  :key="'indexs-' + indexs"
                  style="border-bottom: 2px solid #6d6d6d3d">
                <template class="labelStyle" v-slot:label>
                  <div class="mt-3 mb-3"
                       style="text-align: right;"
                       v-if="item.shop_id == 0 || (item.shop_id == 1 && AllDataBasket.shop_delivery != false)">
                    <h5>
                      {{ oracle.translate(item.shop_name) }}
                    </h5>
                    <p style="font-size: 13px; color: #9a9696; text-align: justify;margin-left: 25px; margin-right: 25px;">
                      {{ oracle.translate(item.shop_brif) }}
                    </p>
                  </div>
                </template>
              </v-radio>
            </v-radio-group>
          </div>
          <div v-if="CheckBasket == 3" style="margin: 0 10px 0 10px; line-height: 2">
            <h5 class="mt-3 mb-5" style="border-bottom: 2px solid #b8b7b7;">{{ oracle.translate('جزئیات خرید') }}</h5>
            <div
                style="border-bottom: 1px solid #b8b7b7; display: flex; justify-content: space-between"
                v-for="(item, itemIndex) in AllDataBasket.basket" :key="'itemIndex-' + itemIndex">
              <span style="font-size: 14px" class="multi-line">{{ oracle.product_title(item) }} ({{
                  item.product_count
                }})</span>
              <span style="color: #7dc353; font-size: 15px;">
                        {{
                  oracle.format(item.product_count * item.product_sell_price)
                }} {{ oracle.translate('تومان') }}</span>
            </div>
            <div class="d-flex flex-row justify-space-between" style="border-bottom: 1px solid #b8b7b7;"
                 v-if="GetLastData != null && GetLastData.options != null && GetLastData.options > 0">
              <span style="font-size: 14px">{{ oracle.translate('هزینه ملزومات سفارش') }}</span>
              <span style="color: #7dc353; font-size: 15px;">{{
                  oracle.format(GetLastData.options)
                }} {{ oracle.translate('تومان') }}</span>
            </div>
            <div class="d-flex flex-row justify-space-between" style="border-bottom: 1px solid #b8b7b7;"
                 v-if="GetLastData != null && GetLastData.packaging != null && GetLastData.packaging > 0">
              <span style="font-size: 14px">هزینه بسته بندی</span>
              <span style="color: #7dc353; font-size: 15px;">{{
                  oracle.format(GetLastData.packaging)
                }} {{ oracle.translate('تومان') }}</span>
            </div>
            <div class="d-flex flex-column" v-if="GetLastData != null">
              <div class="d-flex flex-row justify-space-between" style="border-bottom: 1px solid #b8b7b7;"
                   v-if="GetLastData.delivery != null && GetLastData.delivery > 0">
                        <span style="font-size: 14px">
                            {{ oracle.translate('هزینه ارسال با پیک') }}
                        </span>
                <span style="color: #7dc353;  font-size: 15px;">
                            {{ oracle.format(GetLastData.delivery) }} {{ oracle.translate('تومان') }}
                        </span>
              </div>
              <div class="credit-box d-flex flex-row align-center prx-2 plx-2 mt-2 mb-1 rounded"
                   :style="credit_switch ? 'background: #7dc353;' : 'background: #aaaaaa;'"
                   style="background: #7dc353; color: white !important;"
                   v-if="GetLastData.credit != null && GetLastData.credit > 0">
                <v-switch style="transform: scaleX(-1);" color="white" v-model="credit_switch"></v-switch>
                <span class="mlx-auto mrx-2" style="font-size: 14px; color: white !important;">
                            {{ oracle.translate('استفاده از اعتبار کیف پول') }}
                        </span>
                <span style="color: white !important;  font-size: 15px;">
                            {{ oracle.format(GetLastData.credit) }} {{ oracle.translate('تومان') }}
                        </span>
              </div>
              <div class="d-flex flex-row justify-space-between" style="border-bottom: 1px solid #b8b7b7;"
                   v-if="GetLastData.vat != null && GetLastData.vat > 0">
                        <span style="font-size: 14px">
                            {{ oracle.translate('مالیات ارزش افزوده') }}
                        </span>
                <span style="color: #7dc353;  font-size: 15px;">
                            {{ oracle.format(GetLastData.vat) }} {{ oracle.translate('تومان') }}
                        </span>
              </div>
              <div class="d-flex flex-row justify-space-between font-weight-bold pt-2 pb-2"
                   style="border-bottom: 1px solid #b8b7b7;"
                   v-if="GetLastData.order != null && GetLastData.order > 0">
                        <span style="font-size: 14px">
                            {{ oracle.translate('مبلغ نهایی سفارش') }}
                            <br>
                            <span class="font-weight-medium">
                              {{
                                (
                                    GetLastData.discount_percent != null && GetLastData.discount_percent > 0 ? ("با اعمال " + GetLastData.discount_percent + " " + oracle.translate('درصد تخفیف') + " ")
                                        : (GetLastData.discount_amount != null && GetLastData.discount_amount > 0 ? (oracle.format(GetLastData.discount_amount)) + ' تومان تخفیف محصولات' : '')
                                )
                              }}
                            </span>
                        </span>
                <span style="color: #7dc353; font-size: 15px;">
                            {{ oracle.format(GetLastData.order) }} {{ oracle.translate('تومان') }}
                        </span>
              </div>
              <div class="d-flex flex-row" style="border-bottom: 1px solid #b8b7b7;"
                   v-if="GetLastData.coupon != null">
                        <span class="mlx-auto" style="color: #7dc353;  font-size: 15px;">
                            {{ "✓" + " " + GetLastData.coupon }}
                        </span>
              </div>
            </div>
            <h5 v-if="GetLastData != null && GetLastData.optionsText != null && GetLastData.optionsText.length > 0"
                style="color:#7dc353; margin-top: 5px">
              {{ oracle.translate('ملزومات سفارش') }}
            </h5>
            <p style="white-space: pre-wrap;"
               v-if="GetLastData != null && GetLastData.optionsText != null && GetLastData.optionsText.length > 0">
              {{ GetLastData.optionsText }}
            </p>
            <div v-if="GetLastData != null && GetLastData.optionsText != null && GetLastData.optionsText.length > 0"
                 style="border-bottom: 1px solid #b8b7b7; width: 100%"></div>
            <h5 style="color:#7dc353; margin-top: 5px">
              {{ oracle.shop_name(AllDataBasket) }}
            </h5>
            <div style="display: flex; flex-direction: column; font-size: 15px"
                 v-if="oracle.getData('payment_order_type') == 2">
              <span class="font-weight-bold">{{ oracle.translate('تحویل درب فروشگاه') }}</span>
              <p>{{ oracle.shop_address(AllDataBasket) }}</p>
            </div>
            <div style="display: flex; flex-direction: column; font-size: 15px"
                 v-if="oracle.getData('payment_order_type') == 1">
              <span class="font-weight-bold">{{ oracle.translate('تحویل درب منزل') }}</span>
              <p>{{ address_description }}</p>
            </div>
          </div>
          <div v-if="CheckBasket == 4"
               style="overflow-y: hidden">
            <div class="address-box">
              <v-radio-group class="mrx-2" v-if="AllProfile != null" v-model="radiosAddress" mandatory>
                <v-radio
                    class="labelStyle"
                    v-for="(item, i) in AllProfile.user_addresses"
                    :key="'i-' + i"
                    :value="item"
                    style="border-bottom: 2px solid #6d6d6d3d">
                  <template class="labelStyle" v-slot:label>
                    <div class="mt-3 mb-3" style="text-align: right;">
                      <h5 class="">
                        {{ item.address_title }}
                      </h5>
                      <p class="mb-0"
                         style="font-size: 13px; color: #9a9696; text-align: justify;"
                      >
                        {{ item.address_description }}
                      </p>
                    </div>
                  </template>
                </v-radio>
              </v-radio-group>
              <div v-ripple role="button" @click="CheckBasket = 5"
                   class="add-address"
                   style="display: flex; margin: 0 10px 0 10px;">
                <v-icon style="font-size: 32px; color: #7dc353; margin-left: 5px; margin-right: 5px;">create
                </v-icon>
                <div class="d-flex flex-column mt-5 mb-5">
                                <span style="font-size: 15px; color: black" class="btn-add font-weight-bold">
                                    {{ oracle.translate('ویرایش و حذف آدرس های من') }}
                                </span>
                  <span style="font-size: 12px !important;">
                                    {{
                      oracle.translate('برای ویرایش و یا حذف آدرس های ثبت شده خود از این بخش استفاده کنید')
                    }}
                                </span>
                </div>
              </div>
              <div v-ripple role="button" @click="SetItemMap()"
                   class="add-address"
                   style="display: flex; margin: 0 10px 0 10px; align-items: center">
                <v-icon style="font-size: 32px; color: #7dc353; margin-left: 5px;margin-right: 5px;">add_circle
                </v-icon>
                <div class="d-flex flex-column mt-5 mb-5">
                                <span style="font-size: 15px; color: black" class="btn-add font-weight-bold">
                                    {{ oracle.translate('افزودن آدرس جدید') }}
                                </span>
                  <span style="font-size: 12px !important;">
                                    {{ oracle.translate('برای ایجاد آدرس های جدید از این بخش استفاده کنید') }}
                                </span>
                </div>
              </div>
            </div>
          </div>
          <div v-if="CheckBasket == 5"
               style="overflow-y: hidden">
            <div v-if="AllProfile != null" class="address-box" style="margin: 0 10px 0 10px">
              <div
                  class="d-flex flex-row"
                  style="align-items: center; border-bottom: 1px solid lightgray"
                  v-for="(item, indext) in AllProfile.user_addresses"
                  :key="'indext-' + indext">
                <v-icon
                    v-ripple role="button" @click="SetItemMap(item)"
                    style="color: #7dc353;  margin-left: 10px; margin-right: 10px;">create
                </v-icon>
                <div class="d-flex flex-column mrx-2 mlx-auto mt-3 mb-3">
                  <h5 style="text-align: right">
                    {{ item.address_title }}
                  </h5>
                  <span style="font-size: 13px; color: #9a9696; text-align: right;">
                                    {{ item.address_description }}
                                </span>
                </div>
                <v-icon v-ripple role="button" @click="removeAddress(item)">remove</v-icon>
              </div>
            </div>
          </div>
        </div>
        <div style="height: 100px;"></div>
        <div class="btn-footer-price mt-auto">
          <v-btn style="height: 50px; font-weight: bold !important; border-radius: 0 !important;"
                 :disabled="CheckBasket == 0 || CheckBasket == 5 || showModal || isRequesting"
                 color="#7ec352"
                 v-ripple role="button" @click="Confirm">
            {{ oracle.translate('ادامه ثبت سفارش') }}
            <i :class="isEN ? 'mdi-chevron-right' : 'mdi-chevron-left'"
               style="font-size: 20px" class="mdi"></i>
          </v-btn>
        </div>
      </template>
      <template v-else-if="isAllowed != null && !isAllowed">
        <div class="d-flex flex-column basketAllowBox">
          <img alt="" src="../assets/image/cluna.jpg">
          <span>{{ purchaseAllowMessage }}</span>
          <v-btn color="white" rounded role="button" v-ripple @click="drawer = false">
            {{ oracle.translate('بستن سبد خرید') }}
          </v-btn>
        </div>
      </template>
      <template v-else>
        <div class="d-flex flex-column" style="width: 100%; height: 100%;">
          <v-progress-circular indeterminate color="#7ec352" style="margin: auto"></v-progress-circular>
        </div>
      </template>
    </v-navigation-drawer>

    <v-dialog
        v-model="dialoglog"
        max-width="600"
        transition="scroll-y-transition"
    >
      <v-card class="box-modal headers">
        <div class="title-dialoglog" v-if="flag == 0">
          <v-icon
              :style="isEN ? 'padding-right: 5px;' : 'padding-left: 5px;'"
          >mdi-login
          </v-icon>
          <span class="font-weight-bold">{{ oracle.translate('ورود / ثبت نام حساب کاربری') }}</span>
        </div>
        <p v-if="flag == 0" style="font-size: 12px; margin-right: 20px; margin-left: 20px">
          {{ oracle.translate('برای ایجاد سفارش و استفاده از امکانات سایت شماره موبایل 11 رقمی خود را وارد نمایید.') }}
        </p>
        <div class="title-dialoglog" v-if="flag == 1">
          <v-icon
              :style="isEN ? 'padding-right: 5px;' : 'padding-left: 5px;'"
          >mdi-login
          </v-icon>
          <span class="font-weight-bold">{{ oracle.translate('تایید هویت') }}</span>
        </div>
        <p v-if="flag == 1" style="font-size: 12px; margin-right: 20px; margin-left: 20px;">
          {{
            oracle.translate("کد تایید به شماره همراه شما ارسال شد، لطفا پس از وارد نمودن کد تایید 'نهایی سازی' را لمس کنید.")
          }}
        </p>
        <div class="title-dialoglog" v-if="flag == 2">
          <v-icon
              :style="isEN ? 'padding-right: 5px;' : 'padding-left: 5px;'"
          >mdi-edit
          </v-icon>
          <span class="font-weight-bold">{{ oracle.translate('تکمیل حساب کاربری') }}</span>
        </div>
        <p v-if="flag == 2" style="font-size: 12px; margin-right: 20px; margin-left: 20px;">
          {{
            oracle.translate("جهت بهبود روند ثبت و پیگیری سفارش, لطفا نام و نام خانوادگی خود را وارد نمایید.")
          }}
        </p>
        <div class="fieldphone mt-5 mb-5" v-if="flag == 0">
          <v-text-field autofocus
                        :placeholder="oracle.translate('مثال: 09123456789')"
                        v-model="phone"
                        color="#000"
                        persistent-hint
                        :hint="oracle.translate('شماره تلفن همراه')"
          ></v-text-field>
        </div>
        <div class="fieldphone mt-5 mb-5" v-if="flag == 1">
          <v-otp-input length="4" style="direction: ltr !important;"
                       v-model="code"
                       color="#000"
          ></v-otp-input>
        </div>
        <div class="fieldphone mt-5 mb-5" v-if="flag == 2">
          <v-text-field autofocus
                        :placeholder="oracle.translate('مثال: علی رضایی')"
                        v-model="username"
                        color="#000"
                        :error="usernameError"
                        persistent-hint
                        :hint="oracle.translate('نام و نام خانوادگی')"
          ></v-text-field>
        </div>
        <div class="footer-modal">
          <div class="btn-recive-code">
            <v-btn :disabled="pending" class="font-weight-bold f20" color="#7dc353" v-ripple role="button"
                   @click="Login()">
              <span class="f9" style="color: white">{{ getButtonText() }}</span>
            </v-btn>
          </div>
          <v-btn color="#888" outlined v-ripple role="button" @click="flag = 0" v-if="flag == 1">
            {{ oracle.translate('تصحیح شماره موبایل') }}
          </v-btn>
          <div class="btn-close">
            <v-btn v-if="flag != 2" color="#7dc353" outlined v-ripple role="button" @click="dialoglog = false">
              {{ oracle.translate('انصراف') }}
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Placeholder from "@/components/Placeholder";
import oracle, {event} from "@/oracle";
import {
  mapir,
  mapMarker,
  mapPopup,
  mapAttributionControl,
  mapNavigationControl,
  mapGeolocateControl,
  mapScaleControl,
} from "mapir-vue";

export default {
  name: "Header",
  components: {
    Placeholder,
    mapir,
    mapPopup,
    mapNavigationControl,
    mapMarker,
    mapAttributionControl,
    mapGeolocateControl,
    mapScaleControl,
  },
  data: () => ({
    selectedCoupon: null,
    coupons: [],
    suggests: [],
    productMap: {},
    productExpanded: {},
    apiKey: "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6Ijc3OTZjOTI0MGJlNzA2ODFhZjkwOGZmNjJkMmNmZDZjZGEyZGZiYjg5ZTk1YzYwYmI5ODFkZDA1ZGM4YWUzMDdlZmE1YmEwMGEwMDUyNTcxIn0.eyJhdWQiOiIxMjg0MyIsImp0aSI6Ijc3OTZjOTI0MGJlNzA2ODFhZjkwOGZmNjJkMmNmZDZjZGEyZGZiYjg5ZTk1YzYwYmI5ODFkZDA1ZGM4YWUzMDdlZmE1YmEwMGEwMDUyNTcxIiwiaWF0IjoxNjEzNTYxNDIwLCJuYmYiOjE2MTM1NjE0MjAsImV4cCI6MTYxNjA2NzAyMCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.PGE1y2V5xX6kKL5qG08k21qZ5fzge8RD_DaBkMuQW7vOdHFzwnM1rGnuiCQ9dPw7irbURXkNT5SdLRWGAjDzahK4dH6Y4QT3DScuEm05ZSozzgWaBMNDdQmBF8-Hi01StkZqBP4wrZMLO1PpxgEe9zjbZRSY_yfFr4usUuSyYeYxT3DPo4GrDz7WFWzpl73mKl30ka_THDdPj0d3f_cnwAOsZuETS3hzeb_duplYGIbwJAFZ4OsTlVKYnxPp8lHyboa3rwP0I3inQB2o-lzZFJjsEGZYhVKZeayUR_3t4DthI52NJvJDvTYb-yAs5zXcm6vWDnWEc0Kd9pp45qPcAQ",
    showModal: false,
    loginIsTrue: false,
    CheckDisable: false,
    oracle: oracle,
    isEN: oracle.isEN(),
    flag: 0,
    NumberBasket: 0,
    code: null,
    username: '',
    usernameError: false,
    phone: null,
    radios: null,
    radiosAddress: null,
    drawer: false,
    path: "",
    dialoglog: false,
    search: false,
    searchInput: "",
    AllDataBasket: {},
    drawerMenu: false,
    dialog: false,
    CheckBasket: 0,
    store: [
      {
        shop_id: 1,
        shop_name: "سفارش دلیوری (تحویل درب منزل)",
        shop_brif:
            "فروشگاه انتخاب شده، دارای قابلیت ارسال با پیک جهت تحویل درب منزل میباشد. توجه فرمائید محدوده ارسال تا شعاع 1.5 کیلومتری میباشد. هزینه پیک نیز به صورت جداگانه محاسبه خواهد شد.",
      },
      {
        shop_id: 0,
        shop_name: "سفارش حضوری (تحویل در فروشگاه)",
        shop_brif:
            "در صورت انتخاب این گزینه، میبایست جهت تحویل گرفتن سفارش به صورت حضوری به فروشگاه مراجعه کنید و سفارش خود را با اعلام کد سفارش تحویل بگیرید",
      },
    ],
    pending: false,
    product: null,
    AllProfile: null,
    isRequesting: false,
    center: [51.420296, 35.732379],
    markerCoordinates: [51.420296, 35.732379],
    id: "",
    address_title: "",
    address_description: "",
    GetLastData: null,
    user_addresses: [],
    credit_switch: false,
    listSearch: [],
    currentAddress: null,
    purchaseAllowMessage: null,
    isAllowed: null,
    androidLink: null,
  }),
  methods: {
    setOption(item, index, option) {
      let data = this.productMap[item.product_id][index + '-' + option.key]
      this.productMap[item.product_id][index + '-' + option.key] = data ? !data : true
      this.GetCheckShop()
    },
    counterTitle(index) {
      switch (index - 1) {
        case 0:
          return oracle.translate("اول")
        case 1:
          return oracle.translate("دوم")
        case 2:
          return oracle.translate("سوم")
        case 3:
          return oracle.translate("چهارم")
        case 4:
          return oracle.translate("پنجم")
        case 5:
          return oracle.translate("ششم")
        case 6:
          return oracle.translate("هفتم")
        case 7:
          return oracle.translate("هشتم")
        case 8:
          return oracle.translate("نهم")
        case 9:
          return oracle.translate("دهم")
      }
    },
    getButtonText() {
      let buttonText = ''
      switch (this.flag) {
        case 0:
          buttonText = "دریافت کد تایید"
          break
        case 1:
          buttonText = "نهایی سازی"
          break
        case 2:
          buttonText = "ذخیره تغییرات حساب کاربری"
          break
      }
      return oracle.translate(buttonText)
    },
    toggleLanguage() {
      oracle.toggleLanguage();
      this.isEN = oracle.isEN();
      this.$router.go(0);
    },
    toggleItem(item) {
      this.productExpanded[item.product_id] = !(this.productExpanded[item.product_id] != null && this.productExpanded[item.product_id]);
      this.$forceUpdate();
    },
    SetItemMap(item) {
      this.oracle.scrollToTop()
      this.currentAddress = item
      this.address_title = item != null ? item.address_title : null;
      this.address_description = item != null ? item.address_description : null;
      this.markerCoordinates[1] = item != null && item.address_lat != null ? item.address_lat : this.center[1];
      this.markerCoordinates[0] = item != null && item.address_lng != null ? item.address_lng : this.center[0];
      this.showModal = true;
    },
    removeAddress(item) {
      let Address = [];
      for (let i = 0; i < this.AllProfile.user_addresses.length; i++) {
        if (item != this.AllProfile.user_addresses[i]) {
          Address.push(this.AllProfile.user_addresses[i]);
        }
      }
      oracle.axios("user/edit", {user_addresses: Address}, this.FinalSetMap);
    },
    SetMap() {
      let data = {
        address_description: this.address_description,
        address_title: this.address_title,
        address_lat: this.markerCoordinates[1],
        address_lng: this.markerCoordinates[0],
      }
      if (data.address_title == null || data.address_title.length == 0 || data.address_description == null || data.address_description.length == 0) {
        oracle.showMessage(oracle.translate('نام این آدرس و آدرس دقیق پستی خود را مشخص کنید.'), null, null, 'error')
        return;
      }
      if (data.address_lat == this.center[1] || data.address_lng == this.center[0]) {
        oracle.showMessage(oracle.translate('موقعیت جغرافیایی خود را مشخص کنید.'), null, null, 'error')
        return
      }
      if (this.currentAddress != null) {
        let Address = [];
        for (let i = 0; i < this.AllProfile.user_addresses.length; i++) {
          if (this.currentAddress != this.AllProfile.user_addresses[i]) {
            Address.push(this.AllProfile.user_addresses[i]);
          } else {
            Address.push(data)
          }
        }
        oracle.axios(
            "user/edit",
            {user_addresses: Address},
            this.FinalSetMap
        );
        return;
      }
      oracle.axios("user/getProfile", {}, (response) => {
        if (
            response.data.user_addresses &&
            response.data.user_addresses.length > 0
        ) {
          this.user_addresses = response.data.user_addresses;
        } else {
          this.user_addresses = [];
        }
        this.user_addresses.push(data);
        oracle.axios(
            "user/edit",
            {user_addresses: this.user_addresses},
            this.FinalSetMap
        );
      });
    },
    FinalSetMap() {
      this.CheckDisable = false;
      this.showModal = false;
      oracle.axios("user/getProfile", {}, this.GetPData);
    },
    markerOnClick(e) {

    }, hv(data) {
      this.markerCoordinates[1] = data.actualEvent.lngLat.lat;
      this.markerCoordinates[0] = data.actualEvent.lngLat.lng;
      this.$refs.markerr.$data.marker.setLngLat({
        lng: this.markerCoordinates[0],
        lat: this.markerCoordinates[1],
      });
    },
    onError() {
      this.isRequesting = false
    },
    Confirm() {
      if (this.isRequesting) {
        return
      }
      if (oracle.getToken() == null || oracle.getToken() == '') {
        this.flag = 0
        this.dialoglog = true
        return;
      }
      this.isRequesting = true
      let payment_detail = [];
      if (this.CheckBasket == 1) {
        this.radios = null
        this.CheckBasket = 2;
        this.isRequesting = false
      } else if (this.CheckBasket == 2) {
        if (this.radios == 1) {
          this.radiosAddress = null
          this.CheckBasket = 4;
          oracle.axios("user/getProfile", {}, this.GetPData, this.onError);
        } else if (this.radios == 0) {
          for (let i = 0; i < this.AllDataBasket.basket.length; i++) {
            let count = this.AllDataBasket.basket[i].product_count > this.AllDataBasket.basket[i].product_quantity
                ? this.AllDataBasket.basket[i].product_quantity : this.AllDataBasket.basket[i].product_count
            if (count > 0) {
              payment_detail.push({
                product_id: this.AllDataBasket.basket[i].product_id,
                product_quantity: count,
              });
            }
          }
          oracle.setData("payment_order_type", 2)
          oracle.axios(
              "order/generateReceipt",
              {
                coupon_id: this.selectedCoupon,
                payment_detail: payment_detail,
                product_options: this.generateProductMap(),
                payment_order_type: 2,
                shop_id: this.AllDataBasket.shop_id,
              },
              this.GetDataPayment
              , this.onError
          );
          this.CheckBasket = 3;
        } else {
          this.isRequesting = false
        }
      } else if (this.CheckBasket == 3) {
        for (let i = 0; i < this.AllDataBasket.basket.length; i++) {
          let count = this.AllDataBasket.basket[i].product_count > this.AllDataBasket.basket[i].product_quantity
              ? this.AllDataBasket.basket[i].product_quantity : this.AllDataBasket.basket[i].product_count
          if (count > 0) {
            payment_detail.push({
              product_id: this.AllDataBasket.basket[i].product_id,
              product_quantity: count,
            });
          }
        }
        let type = oracle.getData('payment_order_type')
        let data = {
          coupon_id: this.selectedCoupon,
          payment_detail: payment_detail,
          product_options: this.generateProductMap(),
          payment_tag: "https://cluna.app/profile",
          shop_id: this.AllDataBasket.shop_id,
          payment_type: 1,
        }
        if (type == 2 || type == '2') {
          data.payment_order_type = 2
        } else {
          data.payment_order_type = 1
          data.payment_address = this.radiosAddress
        }
        data.payment_from_credit = this.credit_switch
        oracle.axios("payment/create", data, this.GetResultPayment, this.onError);
      } else if (this.CheckBasket == 4) {
        for (let i = 0; i < this.AllDataBasket.basket.length; i++) {
          let count = this.AllDataBasket.basket[i].product_count > this.AllDataBasket.basket[i].product_quantity
              ? this.AllDataBasket.basket[i].product_quantity : this.AllDataBasket.basket[i].product_count
          if (count > 0) {
            payment_detail.push({
              product_id: this.AllDataBasket.basket[i].product_id,
              product_quantity: count,
            });
          }
        }
        oracle.setData("payment_order_type", 1)
        oracle.axios(
            "order/generateReceipt",
            {
              coupon_id: this.selectedCoupon,
              payment_address: this.radiosAddress,
              payment_detail: payment_detail,
              payment_order_type: 1,
              shop_id: this.AllDataBasket.shop_id,
            },
            this.GetDataPayment, this.onError
        );
      } else {
        this.isRequesting = false
      }
    },
    GetResultPayment(response) {
      this.isRequesting = false
      if (response.data == null || response.data.payment_url == null) {
        oracle.clearBasket();
        oracle.showMessage(oracle.translate('خرید شما از اعتبار انجام شد، به بخش پیگیری سفارشات بروید'),
            oracle.translate('پیگیری سفارش'), () => {
              this.$router.push("profile");
            }, 'checked')
      } else {
        window.location = response.data.payment_url;
      }
    },
    GetDataPayment(response) {
      this.GetLastData = response.data;
      if (this.CheckBasket == 4) {
        this.CheckBasket = 3;
      }
      this.isRequesting = false
    },
    GetPData(response) {
      this.AllProfile = response.data;
      this.isRequesting = false
    },
    plusItem(item) {
      if (item.product_count >= item.product_quantity) {
        return;
      }
      item.product_count++;
      oracle.addToBasket(item.product_id);
      this.getNumberBasket();
      this.$root.$emit("checkitem_header");
      this.GetCheckShop()
    },
    minusItem(item) {
      if (item.product_count == 0) {
        oracle.removeAllFromBasket(item.product_id);
        return;
      }
      item.product_count--;
      oracle.removeFromBasket(item.product_id);
      this.getNumberBasket();
      if (item.product_count == 0) {
        this.AllDataBasket.basket.splice(this.AllDataBasket.basket.indexOf(item), 1)
      }
      this.$root.$emit("checkitem_header");
      this.GetCheckShop()
    }, generateProductMap() {
      let productMap = []
      for (let key in this.productMap) {
        let value = this.productMap[key]
        if (value != null) {
          let innerArray = []
          for (let key in value) {
            if (value[key] != null && value[key] == true) {
              innerArray.push(key)
            }
          }
          productMap.push({
            product_id: key,
            options: innerArray
          })
        }
      }
      return productMap
    },
    checkAvailability(lambda) {
      if (oracle.getShop() == null) {
        this.CheckBasket = 0;
        return
      }
      oracle.axios('order/checkAvailability', {shop_id: oracle.getShop()}, (res) => {
        this.isAllowed = res.data.isAllowed
        this.purchaseAllowMessage = res.data.message
        this.GetCheckShop()
        if (lambda != null) lambda()
      })
    },
    GetCheckShop() {
      if (
          oracle.getShop() != null &&
          oracle.getBasket() != null &&
          oracle.getBasket().length > 0
      ) {
        this.CheckBasket = 1;
        this.isRequesting = true
        oracle.axios(
            "order/checkOrder",
            {
              order_products: oracle.getBasket(),
              product_options: this.generateProductMap(),
              shop_id: oracle.getShop(),
            },
            (response) => {
              this.isRequesting = false
              if (response.data == null) return
              let basket = response.data.basket
              for (let i = 0; i < basket.length; i++) {
                if (basket[i].product_quantity < basket[i].product_count) {
                  basket[i].product_count = basket[i].product_quantity
                }
                if (this.productMap[basket[i].product_id] == null) {
                  this.productMap[basket[i].product_id] = []
                }
              }
              this.AllDataBasket = response.data;
              this.getCoupons()
              this.getSuggests()
            }
        );
      } else {
        this.CheckBasket = 0;
      }
    },
    GoToProfile() {
      if (oracle.getToken() != null && oracle.getToken().length > 0) {
        this.loginIsTrue = true
        this.$router.push("/profile");
      } else {
        oracle.scrollToTop()
        this.loginIsTrue = false
        this.flag = 0
        this.dialoglog = true;
      }
    },
    Login() {
      switch (this.flag) {
        case 0:
          this.pending = true
          oracle.axios("user/authenticate", {
            phone: this.phone,
          }, (res) => {
            this.code = null
            this.flag = 1;
            this.pending = false
          }, () => {
            this.pending = false
          });
          break
        case 1:
          this.pending = true
          oracle.axios("user/verify", {
            captcha: this.code,
            phone: this.phone,
          }, (res) => {
            oracle.axios("user/getProfile", {}, this.verifyUsername);
          }, () => {
            this.pending = false
          })
          break
        case 2:
          this.pending = true
          if (this.username == null || this.username == "" || this.username.trim() == "") {
            this.usernameError = true
            this.pending = false
          } else {
            const model = {username: this.username};
            oracle.axios("user/edit", model, this.closeLoginProcess);
          }
          break
      }
    },
    verifyUsername(res) {
      if (res.data.username == null || res.data.username.trim() == "" || res.data.username == ".") {
        this.username = '';
        this.pending = false;
        this.flag = 2
        return
      }
      this.closeLoginProcess()
    },
    closeLoginProcess() {
      this.loginIsTrue = true;
      this.dialoglog = false;
      this.pending = false
      if (oracle.getBasket() != null && oracle.getBasket().length > 0) {
        oracle.showMessage(oracle.translate("جهت تکمیل سفارش و مشاهده خرید خود وارد 'سبد خرید' شوید."),
            oracle.translate("مشاهده سبد خرید"), this.openDrawerAndCheckAvailability, 'checked')
      }
    },
    openDrawerAndCheckAvailability() {
      this.checkAvailability(this.openDrawer)
    },
    openDrawer() {
      this.drawer = true
    },
    closeSearch() {
      this.search = false;
      this.searchInput = "";
      this.listSearch = "";
    },
    handleChangeInput(e) {
      let search = e.target.value;
      const model = {"limit_by": 500, "offset_by": 0, "order_by": "priority", "search_by": search};
      if (search === "") {
        this.listSearch = [];
      } else {
        oracle.axios("product/getList", model, this.getDoctorSearch);
      }
    },
    getDoctorSearch(response) {
      this.listSearch = response.data
    },
    getNumberBasket() {
      this.NumberBasket = oracle.getCount();
    }, getCoupons() {
      let basket = oracle.getBasket()
      if (basket == null || basket.length == 0) {
        return
      }
      oracle.axios("coupon/getList", {shop_id: oracle.getShop()}, (res) => {
        let array = []
        for (let j = 0; j < res.data.length; j++) {
          let flag = false
          for (let i = 0; i < basket.length; i++) {
            if (res.data[j].product != null && res.data[j].product.product_id != null
                && basket[i] == res.data[j].product.product_id) {
              flag = true
              break
            }
          }
          if (!flag) {
            array.push(res.data[j])
          }
        }
        this.coupons = array
      })
    }, getSuggests() {
      let basket = oracle.getBasket()
      if (basket == null || basket.length == 0) {
        return
      }
      oracle.axios("product/getSuggests", {
        shop_id: oracle.getShop(),
        basketDetail: basket
      }, (res) => {
        let array = []
        for (let j = 0; j < res.data.length; j++) {
          let flag = false
          for (let i = 0; i < basket.length; i++) {
            if (res.data[j].product_id != null
                && basket[i] == res.data[j].product_id) {
              flag = true
              break
            }
          }
          if (!flag) {
            array.push(res.data[j])
          }
        }
        this.suggests = array
      })
    }, backStep() {
      if (this.CheckBasket == 4) {
        this.CheckBasket = 2
      } else {
        this.CheckBasket--
      }
    }
  },
  watch: {
    group() {
      this.drawer = false;
    },
    $route(to) {
      this.path = to.path;
      this.routerPath = to.meta.page;
    },
    drawer: function (value) {
      if (value == false) {
        this.CheckDisable = false;
      }
    },
  },
  mounted() {
    if (oracle.getToken() != null && oracle.getToken().length > 0) this.loginIsTrue = true;
    this.getNumberBasket();
    this.path = this.$route.fullPath;
    this.searchInput = "";
    this.$root.$on("checkitem", () => {
      this.getNumberBasket();
      if (this.drawer) {
        this.GetCheckShop()
      }
    });
    event.$on('login-popup', () => {
      this.flag = 0
      this.dialoglog = true
      oracle.scrollToTop()
    });
    oracle.axios("setting/getInfo", {"filter_by": "website", 'search_by': 'android_link'}, (res) => {
      this.androidLink = res.data;
    });
  },
};
</script>
<style>
.headers .navigation-css {
  width: 30% !important;
}

.headers .listSearch {
  overflow: auto;
  padding: 0 15px;
  transition: all 0.3s;
  z-index: 10;
  position: absolute;
  top: 74%;
  width: 20.5%;
  left: 16.8%;
}

.headers .listScroll {
  height: 91vh;
}

.headers .searchItem {
  cursor: pointer;
  background: #fff;
  padding: 10px 15px;
  margin-bottom: 5px;
  display: flex;
}

.headers .searchItem a {
  display: flex;
}

.headers .searchItem:first-child {
  margin-top: 5px;
}

.headers .imageSearch {
  width: 50px;
  height: 50px;
  overflow: hidden;
  border-radius: 50px;
}

.headers .imageSearch img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.headers .contentSearch {
  padding: 5px 15px 5px 0;
  text-align: right;
}

.headers .contentSearch span {
  font-size: 11px;
}

.headers .contentSearch h4 {
  font-size: 13px;
  font-weight: bold;
}

.headers .MainMapCss {
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12) !important;
  height: auto !important;
  z-index: 30000;
}

.headers .MainMapCss_Sub {
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12) !important;
  display: flex;
  position: absolute;
  z-index: 30000;
  width: 70%;
}

.headers .CssBtnMap .v-btn__content {
  display: unset !important;
}

.headers .ModalCss {
  z-index: 299;
  width: 100%;
  position: absolute;
  right: 0;
  bottom: 0;
  background-color: white;
  padding: 0 10px 0 10px;
}

.headers .CssGun {
  display: none !important;
}

.headers .ModalCssBase {
  z-index: 300;
  right: 0;
  position: absolute;
  width: 100% !important;
  height: 100% !important;
  background-color: rgba(16, 19, 21, 0.88);
}

.headers .ModalCssAddAdress {
  z-index: 299;
  right: 0;
  position: absolute;
  width: 100% !important;
  height: 100% !important;
  background-color: white;
}

.headers .v-dialog__content {
  width: 30% !important;
  left: unset;
  right: 0;
  z-index: 550 !important;
}

.headers .v-dialog {
  z-index: 550 !important;
}

.headers .menuHumber {
  display: none;
}

.headers .item-menuHumber a {
  text-align: center !important;
}

.headers .headerCluna {
  background: #fff;
  width: 100%;
  height: 65px;
  display: flex;
  align-items: center;
  position: relative;
}

.headers .headerCluna button {
  height: 32px !important;
  font-size: 11px !important;
}

.headers .btn-r-headerCluna {
  display: flex;
}

.headers .btn-store {
  color: #fff !important;
  font-size: 14px !important;
  box-shadow: none !important;
  width: fit-content !important;
  min-width: fit-content !important;
  flex: unset !important;
}

.headers .btn-log {
  font-size: 14px !important;
  margin-right: 5px;
  margin-left: 5px;
  background: #fff !important;
  width: fit-content !important;
  min-width: fit-content !important;
  flex: unset !important;
  height: 33px !important;
}

.headers .btn-store .v-icon,
.headers .btn-log .v-icon {
  padding: 0 5px;
  font-size: 18px !important;
}

.headers .btn-store span,
.headers .btn-log span {
  font-size: 14px !important;
}

.headers .dl-app,
.headers .dl-google-play,
.headers .dl-cafe-bazar {
  border-radius: 25px !important;
  box-shadow: none !important;
  width: fit-content !important;
  min-width: fit-content !important;
  flex: unset !important;
}

.headers .dl-app a,
.headers .dl-google-play a,
.headers .dl-cafe-bazar a {
  color: #fff !important;
}

.headers .dl-app {
  margin-right: 5px;
  margin-left: 5px;
}

.headers .l-headerCluna {
  display: flex;
  justify-content: flex-end;
  padding: 15px 0;
  align-items: center;
}

.headers .like-headerCluna .v-icon,
.headers .search-headerCluna .v-icon {
  color: #7ec352 !important;
  font-size: 28px !important;
  padding: 0 5px;
}

.headers .like-headerCluna .v-btn {
  background: none !important;
  box-shadow: none !important;
}

.headers .like-headerCluna:hover i {
  animation: shake 0.5s infinite;
}

@keyframes shake {
  0% {
    transform: rotate(0deg);
  }

  20% {
    transform: rotate(-10deg);
  }

  60% {
    transform: rotate(-10deg);
  }

  80% {
    transform: rotate(10deg);
  }
  100% {
    transform: rotate(0deg);
  }
}

.headers .drawerInfo {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: 16px;
}

.headers .drawerInfo .v-list-item i {
  color: #005ea7 !important;
}

.headers .drawerInfo .v-list-item__titl:active,
.headers .drawerInfo .v-list-item__titl:focus,
.headers .drawerInfo .v-list-item__title {
  color: #005ea7 !important;
}

.headers .header-mobile {
  height: 80px;
  width: 100%;
  background-color: #005ea7;
  padding: 20px 10px;
  text-align: right;
  color: #fff;
  display: flex;
  flex-direction: row;
  position: relative;
}

.headers .text-header-mobile {
  font-size: 14px;
  text-align: right;
  font-weight: bold;
  margin-right: 10px;
  margin-left: 10px;
  margin-top: 5px;
}

.headers .cup-img-cluna {
  width: 250px;
  height: 70px;
}

.headers .logo-img-cluna {
  width: 330px;
  height: 70px;
}

.headers .logo-img-cluna {
  display: flex;
  justify-content: flex-end !important;
}

.headers .cup-img-cluna img,
.headers .logo-img-cluna img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.headers .logo-header {
  background: #fff;
}

.headers .title-drwer {
  display: flex;
  flex-direction: column;
  background-color: #393939;
  height: 90px;
  line-height: 30px;
  padding: 5px 15px !important;
}

.headers .header-drewer span,
.headers .choose-branch .v-icon,
.headers .choose-branch span {
  color: #f2f2f2;
}

.headers .header-drewer .v-icon {
  color: #eee !important;
  font-weight: bold;
}

.headers .header-drewer {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.headers .header-drewer .v-icon,
.headers .choose-branch .v-icon {
  font-size: 18px !important;
}

.headers .header-drewer span,
.headers .choose-branch span {
  font-size: 12px;
}

.headers .choose-branch {
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-top: 15px;
}

.headers .choose-branch .v-icon {

}

.headers .box-products {
  height: auto;
  overflow: auto;
}

.headers .nav-cluna {
  background: #f2f2f2;
  width: 100%;
}

.headers .menu-cluna {
  position: relative;
}

.headers .menu-cluna ul {
  display: flex;
  justify-content: center;
  padding: 0 !important;
}

.headers .menu-cluna ul li {
  /* padding: 0 2.5em;
        margin: 0 auto; */
  position: relative;
  display: inline-block;
  padding: 25px 5px;
  flex-grow: 1;
  text-align: center !important;
  position: relative;
  transition: all 300ms cubic-bezier(0.175, 0.885, 0.32, 1.275);
  line-height: 50px;
  overflow: hidden;
  z-index: 1;
}

.headers .menu-cluna ul li a {
  font-size: 14px;
  color: #808080;
  position: absolute;
  width: 100%;
  height: 100%;
  right: 0;
  top: 0;
  z-index: 10;
}

.headers .menu-cluna ul li::after {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  background: #7dc353;
  top: 0;
  left: 0;
  z-index: -1;
  transition: all 300ms cubic-bezier(0.175, 0.885, 0.32, 1.275);
  transform: translateY(-125%) rotate(-5deg);
}

.headers .menu-cluna ul li:hover::after {
  transform: translateY(0) rotate(0deg);
  z-index: 0;
}

.headers .menu-cluna ul li:hover a {
  color: #fff;
}

.headers .router-link-active::after {
  transform: translateY(0) rotate(0deg) !important;
  z-index: 0 !important;
}

.headers .router-link-active a {
  color: #fff !important;
}

.headers .language-switch {
  background-color: #fff !important;
  color: #7dc353 !important;
  border: solid 2px #7dc353 !important;
}

.headers .img-box-product {
  width: 70px;
  height: 70px;
  border-radius: 50px;
  overflow: hidden;
}

.headers .img-box-product img {
  width: 100%;
  height: 100%;
}

.headers .text-box-product h6 {
  color: #000;
  font-size: 13px;
  text-align: right;
}

.headers .text-box-product span {
  color: #7dc353;
  font-weight: bold;
  font-size: 14px;
  text-align: right;
}

.headers .text-box-product {
  margin: 15px 10px;
}

.headers .box-product-r,
.headers .box-product,
.headers .box-product-l ul {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.headers .box-product-l ul {
}

.headers .box-product {
  justify-content: space-between;
  padding: 10px 15px;
  border-bottom: 1px solid #aaa;
  align-items: center;
}

.headers .box-product-l {
  font-size: 12px;
  background-color: #7dc353;
  border-radius: 30px;
  padding: 2px 5px;
}

.headers .box-product-l i {
  transform: scale(0.8) !important;
}

.headers .title-dialoglog {
  display: flex;
  color: #333;
  padding: 10px 15px;
}

.headers .title-dialoglog .v-icon {
  font-size: 17px !important;
  color: #333 !important;
}

.headers .box-modal {
  padding: 5px 0;
}

.headers .fieldphone {
  padding: 5px 20px;
}

.headers .fieldphone .v-text-field--outlined .v-input__slot {
  min-height: 35px !important;
}

.headers .btn-recive-code button {
  color: #fff !important;
  margin: 10px 0;
  font-size: 12px !important;
}

.headers .footer-modal {
  border-top: 1px solid #e9ecef;
  padding: 5px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  color: #007bff !important;
}

.headers .v-otp-input input {
  text-align: center !important;
}

.headers .searchWapper {
  width: 0%;
  z-index: 10;

  overflow: hidden;
  transition: all 0.3s;
  height: 35px;
  background: #fff;
  border-bottom: 1px solid #7ec352;
}

.headers .openWapper {
  width: 80%;
}

.headers .searchBox {
  display: flex;
  align-items: center;
}

.headers .searchInput .v-input__slot {
  box-shadow: none !important;
  font-size: 12px;
}

.headers .btnClose .v-icon {
  color: #7dc353 !important;
}

.headers .searchBox .v-text-field.v-text-field--solo .v-input__control {
  min-height: 0;
}

.headers .searchBox label {
  font-size: 12px;
}

.headers .btnstore {
  position: relative;
}

.headers .btnstore button {
  font-size: 12px !important;
}

.headers .bdg-store {
  width: 25px;
  text-align: center !important;
  height: 25px;
  background: red;
  color: #fff;
  padding-top: 3px;
  border-radius: 50%;
  position: absolute;
  top: -3px;
  line-height: 20px;
  font-size: 13px;
  z-index: 3;
}

.headers .v-navigation-drawer {
  z-index: 20;
  background: #ffffff !important;
}

.headers .footer-drwer {
  padding: 10px 15px;
  border-top: 1px solid #393939;
  text-align: center !important;
}

.headers .box-footer-price {
  display: flex;
  justify-content: space-between;
  color: #666;
  line-height: 30px;
}

.headers .box-footer-price span {
  font-size: 13px;
}

.headers .item-footer-drwer span:first-child {
  color: #000;
  font-size: 18px;
  padding: 0 5px;
}

.headers .basketAllowBox {
  padding-top: 40%;
  align-items: center;
  justify-items: center;
  width: 100%;
  height: 100%;
  background: #7fc452;
}

.headers .basketAllowBox span {
  text-align: center !important;
  padding: 30px;
  font-weight: bold;
  color: white;
}

.headers .credit-box .v-input--selection-controls__input {
  direction: ltr !important;
}

.headers .basketAllowBox button span {
  text-align: center !important;
  padding: 30px;
  font-weight: bold;
  color: #7fc452;
}

.headers .basketAllowBox img {
  width: 150px;
  height: 150px;
  max-width: 150px;
  max-height: 150px;
}

.headers .btn-footer-price {
  margin-top: auto;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

.headers .btn-footer-price button {
  color: #fff !important;
  font-size: 13px !important;
  width: 100%;
}

.headers .activeMenu {
  display: flex !important;
}

/*@media only screen and (max-width: 480px) {*/
/*  .headers .navigation-css {*/
/*    width: 100% !important;*/
/*  }*/

/*  .headers .v-dialog__content {*/
/*    width: 100% !important;*/
/*  }*/

/*  .headers .menu-cluna ul {*/
/*    display: none;*/
/*  }*/

/*  .headers .menuHumber {*/
/*    display: flex;*/
/*    height: 45px;*/
/*    background: #666;*/
/*  }*/

/*  .headers .menuHumber .v-icon {*/
/*    display: flex !important;*/
/*    margin: 0 auto;*/
/*    color: #fff !important;*/
/*    font-size: 33px !important;*/
/*  }*/

/*  .headers .item-menuHumber {*/
/*    display: none;*/
/*    position: absolute;*/
/*    width: 100%;*/
/*    left: 0;*/
/*    top: 40px;*/
/*    flex-direction: column;*/
/*    background: #666666;*/
/*    z-index: 200;*/
/*  }*/

/*  .headers .item-menuHumber li::after {*/
/*    display: none;*/
/*  }*/

/*  .headers .item-menuHumber li::before {*/
/*    display: none;*/
/*  }*/

/*  .headers .headerCluna {*/
/*    height: auto;*/
/*  }*/

/*  .headers .searchWapper {*/
/*    order: 2;*/
/*  }*/

/*  .headers .search-headerCluna {*/
/*    order: 3;*/
/*  }*/

/*  .headers .search-headerCluna,*/
/*  .headers .btnClose {*/
/*    order: 3;*/
/*  }*/

/*  .headers .like-headerCluna {*/
/*    order: 1;*/
/*    margin-left: auto;*/
/*  }*/

/*  .headers .bdg-store {*/
/*    top: 15px;*/
/*    right: 20px;*/
/*  }*/
/*}*/
</style>
